import { useEffect } from "react";
import { toast } from "sonner";

// Listens for the "cls:degraded-storage" event that src/api/base44Client.js emits whenever
// a hosted-portal request fails and the client silently falls back to browser-local
// storage. Without this the user sees an ordinary success state for a record that never
// reached the shared database - see the comment on `reportDegradedSave`.
//
// Mounted once near the app root; it renders nothing itself.
export default function DegradedStorageNotice() {
  useEffect(() => {
    const handler = (event) => {
      const { isWrite, operation } = event.detail || {};
      if (isWrite) {
        toast.error("This wasn't saved to the shared system", {
          description:
            "It's only stored in this browser for now. Check your connection and save again - other staff cannot see it yet.",
          duration: 15000,
          id: `degraded-write-${operation}`,
        });
      } else {
        toast.warning("Showing locally cached information", {
          description:
            "The shared system could not be reached, so this may be out of date. Reload once your connection is back.",
          duration: 8000,
          id: `degraded-read-${operation}`,
        });
      }
    };

    window.addEventListener("cls:degraded-storage", handler);
    return () => window.removeEventListener("cls:degraded-storage", handler);
  }, []);

  return null;
}
